export default __webpack_public_path__ + "static/media/04_menu_800.8bd599f9.gif";